import { RoutesConfig } from "@spartacus/core";

export const uigRoutesConfig: RoutesConfig = {
  home: { paths: [''] },
  notFound: { paths: ['not-found'] },
  cart: { paths: ['cart'] },

  // plp routes
  search: {
    paths: ['search/:query']
  },
  category: {
    paths: ['category/:categoryCode'],
    paramsMapping: { categoryCode: 'code' },
  },
  brand: {
    paths: ['Brands/:brandName/c/:brandCode']
  },

  // pdp routes
  product: {
    paths: [
      'product/:productCode',
      'p/:productCode' // UIG custom route
    ],
    paramsMapping: { productCode: 'code' },
  },

  termsAndConditions: {
    paths: ['terms-and-conditions']
  },
  orders: {
    paths: ['my-account/orders'],
  },
  orderDetails: {
    paths: ['my-account/order/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  orderGuest: {
    paths: ['guest/order/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  orderReturn: {
    paths: ['my-account/order/return/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  orderReturnConfirmation: {
    paths: ['my-account/order/return/confirmation/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  orderCancel: {
    paths: ['my-account/order/cancel/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  orderCancelConfirmation: {
    paths: ['my-account/order/cancel/confirmation/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  returnRequestDetails: {
    paths: ['my-account/return-request/:returnCode'],
    paramsMapping: { returnCode: 'rma' },
  },
  coupons: {
    paths: ['my-account/coupons']
  },
  couponClaim: {
    paths: ['my-account/coupon/claim/:couponCode'],
    paramsMapping: { couponCode: 'code' },
  },
  replenishmentOrders: {
    paths: ['my-account/my-replenishments'],
  },
  replenishmentDetails: {
    paths: ['my-account/my-replenishment/:replenishmentOrderCode'],
    paramsMapping: { replenishmentOrderCode: 'replenishmentOrderCode' },
  },

  // Custom UIG routes are below this line
  // -------------------------------------

  /**
   * Custom UIG routes - protected (user should be logged in)
   */
  // orderHistory: null,
  customStatisticDisplay: {
    paths: ['/myrio/statistic']
  },

  // user payments routes
  userPayments: {
    paths: ['myrio/userpayments'],
  },
  userPaymentsDetails: {
    paths: ['myrio/userpaymentsdetails/:invoiceNumber/:companyCode/:bookingYear/:bookingTime'],
  },
  userPaymentsAvis: {
    paths: ['myrio/userpaymentsavis/:avisNumber/:avisDate'],
  },

  // delivery notes routes
  deliveryNotes: {
    paths: ['/myrio/deliveryNotes']
  },
  deliveryNoteDetails: {
    paths: ['/myrio/deliveryNotesDetail/:deliveryNumber']
  },

  marketplaceDeliveryNotes: {
    paths: ['/myrio/marketplaceDeliveryNotes']
  },
  marketplaceDeliveryNoteDetails: {
    paths: ['/myrio/marketplaceDeliveryNotesDetail/:deliveryNumber']
  },
  //  Vendor Report Routes
  rioDashboard: {
    paths: ['myrio/vendor-report-dashborad'],
  },

  /**
   * Custom UIG routes - unprotected
   */
  contact: {
    paths: ['contact', 'Impressum'],
    protected: false,
  },
  faq: {
    paths: ['faq'],
    protected: false,
  },
};
